import { keepPreviousData, useQuery } from "@tanstack/react-query";
import React from "react";
import { useParams } from "react-router";
import { useDocApiClient } from "../api/apiClients";
import InternalError from "../components/Errors/InternalError";
import { NotFound } from "../components/Errors/NotFound";
import Loading from "../components/Loading";
import { defaultConfig } from "../components/Orion/Config/ConfigDefault";
import ConfigForm from "../components/Orion/Config/ConfigForm";
import { ConfigFormProvider } from "../components/Orion/Config/ConfigFormContext";
import useSession from "../components/useSession/useSession";
import { PipelineConfigDb } from "../interfaces/doc";

export function ConfigPage() {
  const { configId } = useParams<{ configId: string }>();
  const apiClient = useDocApiClient<PipelineConfigDb>();
  const isNew = configId === "new";
  const { data: session } = useSession();

  const {
    data: configDb,
    isLoading,
    isError,
  } = useQuery({
    queryKey: ["config", configId as string],
    queryFn: () => apiClient("GET", `/config/${configId}`),
    placeholderData: keepPreviousData,
    enabled: configId !== "new",
    staleTime: Infinity,
  });

  const canContribute =
    (isNew && (session?.OrionContributorGroups ?? []).length > 0) ||
    (!!configDb &&
      (session?.OrionContributorGroups ?? []).includes(configDb.workspace_id));
  const canView = canContribute;
  // (isNew && (session?.OrionContributorGroups ?? []).length > 0) ||
  // (!!configDb &&
  //   (session?.OrionUserGroups ?? []).includes(configDb.workspace_id));
  const isReadOnly = canView && !canContribute;

  return (
    <React.Fragment>
      {isError ? (
        <InternalError />
      ) : isLoading ? (
        <Loading />
      ) : !canView ? (
        <NotFound />
      ) : (
        <ConfigFormProvider
          isNew={isNew}
          formProps={{
            defaultValues: async () => {
              if (isNew || !configDb) {
                return {
                  config: defaultConfig(),
                  name: `Nouvelle configuration`,
                };
              } else {
                return { config: configDb.config, name: configDb.name };
              }
            },
          }}
          isReadOnly={isReadOnly}
        >
          <ConfigForm configDb={configDb} />
        </ConfigFormProvider>
      )}
    </React.Fragment>
  );
}
